import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { cashfree } from './util'
import { useParams } from 'react-router-dom';

const Cashfree = () => {
    const params = useParams()
    const isSessionId = params.sessionId
    const isOrderId = params.orderId

    const [sessionId, setSessionId] = useState('');

    const handlePayment = ()=>{

        let checkoutOptions = {
            paymentSessionId: sessionId,
            returnUrl: `${process.env.REACT_APP_BASE_URL}/cashfree/payment-status/${isOrderId}`,
        }

        cashfree.checkout(checkoutOptions).then(function(result){
            if(result.error){
                alert(result.error.message);
                return;
            }
            // if(result.redirect){
            //     console.log("Redirection")
            //     console.log(result);
            // }
        });
    }

    useEffect(()=>{
        setSessionId(isSessionId)
    }, [isSessionId])

    useEffect(()=>{
        if(sessionId){
            handlePayment();
        }
    }, [sessionId])

  return (
    <>
    <div className='main'>
            
    </div>
    </>
  )
}

export default Cashfree